import { z } from 'zod';

export const permissionRolesFiltersSchema = z.object({
  roleIds: z.array(z.string()).catch([]),
  search: z.string().catch(''),
});
